module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/bar-icon-63329df127293c382d4c2d1f99cf2b6b.png";